import { cyan, purple } from '@bloomfieldrobotics/canopy';
import { Marker, PointLike } from 'react-map-gl';
import { useDeepCompareMemo } from 'use-deep-compare';
import { useAppSelector } from '../../../../../app/hooks';
import LocationSVG from '../../../icons/LocationSVG';
import {
  selectMapMeasurePoint1,
  selectMapMeasurePoint2,
} from '../../../mapSlice';
import { convertStringToLatLng } from '../../../mapUtils';

export const useMeasureToolMarkers = (offset: PointLike, size: number) => {
  const measurePoint1 = useAppSelector(selectMapMeasurePoint1);
  const measurePoint2 = useAppSelector(selectMapMeasurePoint2);

  const measureMarkers = useDeepCompareMemo(() => {
    const markers: JSX.Element[] = [];

    if (measurePoint1) {
      const latLng = convertStringToLatLng(measurePoint1.point_location);
      if (latLng) {
        markers.push(
          <Marker
            key='measure-point-1'
            longitude={latLng.longitude}
            latitude={latLng.latitude}
            offset={offset}
          >
            <LocationSVG size={size} color={cyan[500]} />
          </Marker>
        );
      }
    }

    if (measurePoint2) {
      const latLng = convertStringToLatLng(measurePoint2.point_location);
      if (latLng) {
        markers.push(
          <Marker
            key='measure-point-2'
            longitude={latLng.longitude}
            latitude={latLng.latitude}
            offset={offset}
          >
            <LocationSVG size={size} color={purple[500]} />
          </Marker>
        );
      }
    }

    return markers;
  }, [measurePoint1, measurePoint2, offset, size]);

  return measureMarkers;
};
